import { selectMerchantCurrency, useAppSelector } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import { ProgressBar } from 'mmfintech-portal-commons'
import './SpendingLimitBar.scss'

interface Props {
  totalAmount: number
  spentMonthlyVolume: number
}

function SpendingLimitBar({ totalAmount, spentMonthlyVolume }: Props) {
  const merchantCurrency = useAppSelector(selectMerchantCurrency)

  return (
    <div className='spending-limit-bar-wrapper'>
      <div className='spent-amount'>
        <div className='available-amount'>
          <span className='available-text'>
            {tr('PORTAL.COMPONENTS.LIMITS_BAR.MONEY_SPENT', 'Money spent')}:{' '}
            <span>{formatMoney(spentMonthlyVolume, merchantCurrency)}</span>
          </span>
        </div>
        <div className='total-amount'>{formatMoney(totalAmount, merchantCurrency)}</div>
      </div>
      <ProgressBar value={spentMonthlyVolume} max={totalAmount} />
    </div>
  )
}

export default SpendingLimitBar
